import Vue from 'vue'
import { URL_ORGANIZATIONS } from '@/constants/urls.js'
import { ORGANIZATION_MANAGEMENT, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'

const state = {
  [ORGANIZATION_MANAGEMENT.STATE.USERS]: null,
  [ORGANIZATION_MANAGEMENT.STATE.ORGANIZATIONS]: null,
  [ORGANIZATION_MANAGEMENT.STATE.CURRENT_ORGANIZATION]: null,
  [ORGANIZATION_MANAGEMENT.STATE.SHORT_INFO_LIST]: null,
  [ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_INFO]: null,
  [ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_CHANGED]: true,
  [ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO]: {
    organizationId: null,
    organizationShortName: null,
    organizationFullName: null,
    participantType: null,
    registrationDate: null,
    country: null,
    managerFIO: null,
    managerPosition: null,
    inn: null,
    kpp: null,
    ogrn: null,
    // postAddress: null,
    // realAddress: null,
    location: null,
    email: null,
    phone: null,
    contactPerson: null,
    contactPersonPosition: null
  }
}

const actions = {
  async [ORGANIZATION_MANAGEMENT.ACTIONS.MERGE_FIELDS] ({ commit }, draft) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.MERGE_FIELDS, draft)
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.ORGANIZATION_CHANGED, true)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATIONS_LIST] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATIONS_LIST, resp.data)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATIONS_SHORT_INFO_LIST] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/list/shortByParticipantType?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATIONS_SHORT_INFO_LIST, resp.data)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATION_USERS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/registeredUsers?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_USERS, resp.data)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATION_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_ADMIN, resp.data)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATION_EDIT_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_EDIT_INFO, resp.data)
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.ORGANIZATION_CHANGED, false)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.GET_REGISTRATION_CARD] ({ commit, dispatch }, model) {
    const url = `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/registrationCard?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.UPDATE_ORGANIZATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.ORGANIZATION_CHANGED, false)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.SEND_TO_CRM] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/crm`,
      model: null
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.SEND_NOTIFICATION_OF_ORGANIZATION_ACCEPTANCE] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/notificationOfOrganizationAcceptance`,
      model: model.emails
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CHANGE_ORGANIZATION_LOCK_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/status`,
      model: { isLocked: model.isLocked }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATIONS_LIST] ({ commit }) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATIONS_LIST)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATIONS_SHORT_INFO_LIST] ({ commit }) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATIONS_SHORT_INFO_LIST)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_ADMIN] ({ commit }) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_ADMIN)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_EDIT_INFO] ({ commit }) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_EDIT_INFO)
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.ORGANIZATION_CHANGED, false)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_USERS] ({ commit }) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_USERS)
  },
  async [ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_INFO] ({ commit }) {
    commit(ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_INFO)
  }
}

const mutations = {
  [ORGANIZATION_MANAGEMENT.MUTATIONS.ORGANIZATION_CHANGED] (state, flag) {
    state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_CHANGED] = flag
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.MERGE_FIELDS] (state, editedFieldsObj) {
    for (const key in editedFieldsObj) {
      state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO][key] = editedFieldsObj[key]
    }
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_EDIT_INFO] (state, organization) {
    for (const key in state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO]) {
      state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO][key] = organization[key]
    }
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATIONS_LIST] (state, organizations) {
    state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATIONS] = organizations
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATIONS_SHORT_INFO_LIST] (state, organizations) {
    state[ORGANIZATION_MANAGEMENT.STATE.SHORT_INFO_LIST] = organizations
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_USERS] (state, users) {
    state[ORGANIZATION_MANAGEMENT.STATE.USERS] = users
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATIONS_LIST] (state) {
    state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATIONS] = null
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATIONS_SHORT_INFO_LIST] (state) {
    state[ORGANIZATION_MANAGEMENT.STATE.SHORT_INFO_LIST] = null
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_ADMIN] (state, organization) {
    state[ORGANIZATION_MANAGEMENT.STATE.CURRENT_ORGANIZATION] = organization
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_INFO] (state) {
    state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_INFO] = null
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_ADMIN] (state) {
    for (const key in state[ORGANIZATION_MANAGEMENT.STATE.CURRENT_ORGANIZATION]) {
      state[ORGANIZATION_MANAGEMENT.STATE.CURRENT_ORGANIZATION][key] = null
    }
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_EDIT_INFO] (state) {
    for (const key in state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO]) {
      state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO][key] = null
    }
  },
  [ORGANIZATION_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_USERS] (state) {
    state[ORGANIZATION_MANAGEMENT.STATE.USERS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
